import { ArrowPathIcon } from '@heroicons/react/24/solid';
import { useSyncExternalStore } from 'react';
import { getSyncState, startSync, subscribeSync } from '../utils/sync-store';

export default function SyncButton() {
  const sync = useSyncExternalStore(subscribeSync, getSyncState);

  const isSyncing = sync.phase === 'master-data' || sync.phase === 'photos';
  const { completed, total } = sync.progress;
  const percent = total > 0 ? Math.round((completed / total) * 100) : 0;

  const label = () => {
    switch (sync.phase) {
      case 'master-data':
        return 'Syncing data...';
      case 'photos':
        return `Photos ${completed}/${total}`;
      case 'done':
        return sync.failed.length > 0
          ? `Synced, ${sync.failed.length} failed`
          : 'Sync complete';
      case 'error':
        return 'Sync failed - retry';
      default:
        return 'Sync Data';
    }
  };

  return (
    <div className="sync-control">
      <button
        onClick={() => startSync()}
        className="options-button"
        disabled={isSyncing}
      >
        <ArrowPathIcon
          className={`sync-icon ${isSyncing ? 'spinning' : ''}`}
          width={20}
          height={20}
        />
        <span>{label()}</span>
      </button>

      {sync.phase === 'photos' && total > 0 && (
        <div
          className="sync-progress"
          role="progressbar"
          aria-valuenow={percent}
          aria-valuemin={0}
          aria-valuemax={100}
        >
          <div className="sync-progress-bar" style={{ width: `${percent}%` }} />
        </div>
      )}

      {sync.phase === 'error' && sync.error && (
        <p className="sync-message sync-message-error">{sync.error}</p>
      )}
    </div>
  );
}
